module.exports = __webpack_public_path__ + "03c9897bcdafb75da1468bee320520e7.fbx";